import { render, staticRenderFns } from "./detailSolveProject.vue?vue&type=template&id=2caa9ac3&scoped=true&"
import script from "./detailSolveProject.vue?vue&type=script&lang=js&"
export * from "./detailSolveProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caa9ac3",
  null
  
)

export default component.exports